export default __webpack_public_path__ + "images/04057f5c1fc325fa7362e72df1d96733.svg";